import { Component, Input } from '@angular/core';
import { Store } from 'src/app/core/stores.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-store-details-general-settings',
  templateUrl: './store-details-general-settings.component.html',
  styleUrls: ['./store-details-general-settings.component.scss'],
})
export class StoreDetailsGeneralSettingsComponent {
  @Input() store?: Store;

  constructor(private utils_service: UtilsService) {}

  getFormattedAmount(amount: number | null | undefined): string {
    if (typeof amount !== 'number' || !isFinite(amount)) {
      return '-';
    }

    const amount_str = Math.round(amount).toString();
    const padded_str = amount_str.padStart(3, '0');
    const integer_part = padded_str.slice(0, -2);
    const decimal_part = padded_str.slice(-2);
    const formatted_integer_part = integer_part.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${formatted_integer_part},${decimal_part}`;
  }

  getCompanySettingsBackgroundClass(settings: boolean): { [key: string]: boolean } {
    return this.utils_service.getCompanySettingsBackgroundClass(settings);
  }
}
